"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Api_1 = require("../Api");
var handleJson_1 = tslib_1.__importStar(require("./handleJson"));
function parseOpenApi3Documentation(entrypointUrl) {
    entrypointUrl = handleJson_1.removeTrailingSlash(entrypointUrl);
    return fetch(entrypointUrl)
        .then(function (res) { return Promise.all([res, res.json()]); })
        .then(function (_a) {
        var res = _a[0], response = _a[1];
        var title = response.info.title;
        var resources = handleJson_1.default(response, entrypointUrl);
        return Promise.resolve({
            api: new Api_1.Api(entrypointUrl, { title: title, resources: resources }),
            response: response,
            status: res.status,
        });
    }, function (_a) {
        var res = _a[0], response = _a[1];
        return Promise.reject({
            api: new Api_1.Api(entrypointUrl, { resources: [] }),
            response: response,
            status: res.status,
        });
    });
}
exports.default = parseOpenApi3Documentation;
//# sourceMappingURL=parseOpenApi3Documentation.js.map